import React, { useState } from "react";
import ModalConfigFixture from "../../../Modals/ModalConfigFixture/ModalConfigFixture";
import ModalConfigSkeletonFixture from "../../../Modals/ModalConfigSkeletonFixture/ModalConfigSkeletonFixture";

const CardConfigFixture = () => {
  const [open, setOpen] = useState(false);
  const [openEsqueleto, setOpenEsqueleto] = useState(false);

  return (
    <>
      <div className="flex justify-center bg-gray-100 p-4">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-2xl w-full">
          <h2 className="text-2xl font-semibold mb-6 text-center text-gray-800">
            Configuración de Fixture
          </h2>
          <div className="flex justify-between mb-3">
            <label className="text-2xl block text-gray-700 mb-2">
              Editar Base de Fixture
            </label>
            <div className="flex justify-center">
              <button
                onClick={() => setOpen(true)}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Configurar
              </button>
            </div>
          </div>

          <div className="flex justify-between">
            <label className="text-2xl block text-gray-700 mb-2">
              Editar Esqueleto de Fixture
            </label>
            <div className="flex justify-center">
              <button
                onClick={() => setOpenEsqueleto(true)}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Configurar
              </button>
            </div>
          </div>
        </div>
      </div>
      {open ? <ModalConfigFixture open={open} setOpen={setOpen} /> : null}
      {openEsqueleto && <ModalConfigSkeletonFixture open={openEsqueleto} setOpen={setOpenEsqueleto} />}
    </>
  );
};

export default CardConfigFixture;
